import { useStore as e } from "/home/runner/work/oko-web/oko-web/node_modules/zustand/esm/react.mjs";
import { createStore as t } from "/home/runner/work/oko-web/oko-web/node_modules/zustand/esm/index.mjs";
import { useShallow as n } from "/home/runner/work/oko-web/oko-web/node_modules/zustand/esm/react/shallow.mjs";
import { SpaceUserRole as r } from "@magnopus-opensource/connected-spaces-platform-web-api";
//#region src/lib/stores/space-users-store/useSpaceUsersStore.ts
var i = /* @__PURE__ */ function(e) {
	return e.ALL = "All", e.CREATORS = "Creators", e.VIEWERS = "Viewers", e.BLOCKED = "Blocked", e;
}({}), a = (e, t, n) => e.filter(({ name: e, role: i, isBlocked: a }) => {
	let o = e?.toLocaleLowerCase().includes(n.toLocaleLowerCase());
	switch (t) {
		case "All": return o;
		case "Blocked": return a && o;
		case "Creators": return (i === r.Moderator || i === r.Owner) && !a && o;
		case "Viewers": return i === r.User && !a && o;
		default: return !1;
	}
}), o = (t) => e(s, n(t)), s = t((e, t) => ({
	allCollaborators: [],
	filteredCollaborators: [],
	searchValue: "",
	filterValue: "All",
	setCollaborators: (n) => {
		let { searchValue: r, filterValue: i } = t();
		e({
			allCollaborators: n,
			filteredCollaborators: a(n, i, r)
		});
	},
	setFilter: (n) => {
		let r = t().allCollaborators;
		e({ filterValue: n }), t().setCollaborators(r);
	},
	setSearch: (n) => {
		let { allCollaborators: r, searchValue: i } = t();
		i !== n && (e({ searchValue: n }), t().setCollaborators(r));
	},
	resetSearch: () => {
		let n = t().allCollaborators;
		e({ searchValue: "" }), t().setCollaborators(n);
	},
	clear: () => {
		e({
			allCollaborators: [],
			filteredCollaborators: [],
			filterValue: "All",
			searchValue: ""
		});
	}
}));
//#endregion
export { i as UsersFilters, s as spaceUsersStore, o as useSpaceUsersStore };
